import { defineAsyncComponent } from 'vue'
import { tabOutlineLayoutDashboard } from 'quasar-extras-svg-icons/tabler-icons-v3'

import type { MainFeatureTwin, FeatureConfig } from 'src/models'

export interface PowerBiReportFeatureTwin extends MainFeatureTwin {
  workspaceId?: string
  reportId: string
}

const featureConfig: FeatureConfig = {
  main: {
    mainComponent: defineAsyncComponent(() => import('./PowerBiReportFeatureMain.vue')),
    fullWidth: true,
    icon: tabOutlineLayoutDashboard,
    label: 'Report'
  }
}

export default featureConfig
